(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/helper-get-products/assets/javascripts/get-products.js') >= 0) return;  svs.modules.push('/components/marketplace/helper-get-products/assets/javascripts/get-products.js');

'use strict';

const _svs$utils$products$p = svs.utils.products.productIds,
  BOMBEN = _svs$utils$products$p.BOMBEN,
  MALTIPSET = _svs$utils$products$p.MALTIPSET,
  FULLTRAFF = _svs$utils$products$p.FULLTRAFF,
  T8 = _svs$utils$products$p.T8,
  T8EXTRA = _svs$utils$products$p.T8EXTRA,
  T8STRYK = _svs$utils$products$p.T8STRYK,
  EUROPATIPSET = _svs$utils$products$p.EUROPATIPSET,
  STRYKTIPSET = _svs$utils$products$p.STRYKTIPSET,
  CHALLENGE = _svs$utils$products$p.CHALLENGE,
  POWERPLAY = _svs$utils$products$p.POWERPLAY,
  RACING = _svs$utils$products$p.RACING;
const _svs$components$lbUti = svs.components.lbUtils.sportProducts,
  getProdName = _svs$components$lbUti.getProdName,
  productIds = _svs$components$lbUti.productIds;
const marketplaceProductIds = [BOMBEN, MALTIPSET, FULLTRAFF, T8, T8EXTRA, T8STRYK, EUROPATIPSET, STRYKTIPSET, CHALLENGE, POWERPLAY, RACING];
const productBase = ['stryktipset', 'europatipset', 'topptipset', 'challenge', 'powerplay', 'bomben'];
const getProducts = function () {
  let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$topptipsSeparate = _ref.topptipsSeparate,
    topptipsSeparate = _ref$topptipsSeparate === void 0 ? false : _ref$topptipsSeparate,
    _ref$withoutRacing = _ref.withoutRacing,
    withoutRacing = _ref$withoutRacing === void 0 ? false : _ref$withoutRacing;
  const products = productBase.slice();
  if (topptipsSeparate && products.find(product => product === 'topptipset')) {
    products.push('topptipset stryk', 'topptipset europa');
  }

  if (withoutRacing) {
    return products.filter(product => product !== getProdName(productIds.RACING));
  }
  return products;
};

const getEnhancedProducts = () => productBase.map(product => ({
  product
}));

setGlobal('svs.components.marketplace.helpers.getEnhancedProducts', getEnhancedProducts);
setGlobal('svs.components.marketplace.helpers.getProducts', getProducts);
setGlobal('svs.components.marketplace.helpers.marketplaceProductIds', marketplaceProductIds);

 })(window);